import config from "@/app/config.js";
import { getApiUrl } from "@/services/_apiUrl";
import * as submissionService from "@/services/submissionService";

const list = {
  namespaced: true,
  state() {
    return {
      submissionList: [],
      loading: false,
      error: null,
      count: 0,
      pagination: {
        skip: 0,
        limit: 20,
      },
    };
  },
  getters: {
    submissionList: (state) => state.submissionList,
    isLoading: (state) => state.loading,
    hasError: (state) => state.error,
    count: (state) => state.count,
    pagination: (state) => state.pagination,
  },
  mutations: {
    setSubmissionList(state, payload) {
      state.submissionList = payload;
    },
    setCount(state, payload) {
      state.count = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    setPagination(state, payload) {
      state.pagination = { ...state.pagination, ...payload };
    },
  },
  actions: {
    async fetchSubmissions({ commit, state }, params = {}) {
      const isDevMode = config.VITE_APP_DEV_MODE === "on";
      const pollMode = params.pollMode || false;

      if (!pollMode) {
        commit("setLoading", true);
      }

      commit("clearError");

      const paginationParams = {
        skip: params.skip === 0 ? 0 : params.skip || state.pagination.skip,
        limit: params.limit || state.pagination.limit,
      };

      commit("setPagination", {
        skip: paginationParams.skip,
        limit: paginationParams.limit,
      });

      const apiUrl = getApiUrl();
      const taskNamesQueryString = params.task_name ? `?task_name=${params.task_name}` : "";
      const { task_name, pollMode: _, ...restParams } = params;
      const finalParams = { ...restParams, ...paginationParams };

      if (isDevMode) {
        finalParams.generate_signed_urls = true;
      }

      try {
        const response = await submissionService.fetchSubmissions(
          `${apiUrl.submission.GET.LIST}${taskNamesQueryString}`,
          finalParams,
        );

        const result = response.data;

        commit("setSubmissionList", result.items);
        commit("setCount", result.count);

        return result;
      } catch (error) {
        commit("setError", error);
        console.error("Error fetching submissions in list store:", error);
        commit("setSubmissionList", []);
        commit("setCount", 0);

        throw error;
      } finally {
        if (!pollMode) {
          commit("setLoading", false);
        }
      }
    },
    async deleteSubmissions(_, params = {}) {
      const { ids } = params;

      try {
        await submissionService.deleteSubmissions(ids);
      } catch (error) {
        console.error("Error deleting submissions in list store:", error);

        throw error;
      }
    },
    clearListResult({ commit }) {
      commit("setSubmissionList", []);
      commit("setCount", 0);
    },
  },
};

export default list;
